<template>
  <el-dialog title="设备余额强制对齐" :visible.sync="show" :before-close="switchDialogShow" width="1200px" height="400px">
    <div v-loading="loading">
      <div class="app-container" style="padding-top: 0; margin-top: -10px">
        <el-form :inline="true">
          <el-form-item label="资产码"> {{ form.assets_code }} </el-form-item>
          <el-form-item label="平台记录余额">
            {{ form.dev_balance_real }}
          </el-form-item>
        </el-form>
        <el-form :inline="true" :model="form">
          <el-form-item label="强制对齐金额" prop="balance_dq">
            <el-input placeholder="请输入强制对齐金额" v-model="form.balance_dq" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-edit" type="primary" @click="onBalanceForceDqSubmit">强制对齐</el-button>
          </el-form-item>
        </el-form>
        <div style="height: 400px">
          <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
            <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
            <el-table-column label="平台余额" prop="dev_balance_real" width="90" align="center"></el-table-column>
            <el-table-column label="设备余额" prop="remote_dev_balance_real" width="90" align="center"></el-table-column>
            <el-table-column label="备注" prop="remark" align="center"></el-table-column>
            <el-table-column label="原因" prop="reason" width="60" align="center"></el-table-column>
            <el-table-column label="地址" prop="fee_table_address" width="120" align="center"></el-table-column>
            <el-table-column label="创建时间" prop="create_time" align="center"></el-table-column>
          </el-table>
        </div>
        <div class="my-pagination">
          <el-pagination
            background
            layout="sizes,total,prev,pager,next,jumper"
            :total="pageParams.total"
            :page-size="pageParams.limit"
            :page-sizes="[5, 10, 50, 100, 500, 1000]"
            :current-page="pageParams.page"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import * as echarts from "echarts"
import { Send_FeeTable_BalanceForceDq } from "@/api/dev_send_order"
import { GetBalanceErrorPageList } from "@/api/dev_fee_table"
export default {
  mixins: [pageMixin],
  name: "PowerCurve",
  props: {},
  data() {
    return {
      show: false,
      loading: false,
      form: {
        ID: 0,
        order_num: 0,
        balance_dq: ""
      },
      tableData: []
    }
  },

  methods: {
    showForceDq(data) {
      this.form.ID = data.ID
      this.form.order_num = data.order_num
      this.form.balance_dq = data.dev_balance_real
      this.form.dev_balance_real = data.dev_balance_real
      this.form.assets_code = data.assets_code
      this.switchDialogShow()
      this.getData()
    },
    getData() {
      this.loading = true
      GetBalanceErrorPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        fee_table_id: this.form.ID
      }).then((res) => {
        this.tableData = res.data
        this.pageParams.total = res.total
        this.loading = false
      })
    },
    onBalanceForceDqSubmit() {
      this.loading = true
      Send_FeeTable_BalanceForceDq({
        feetable_id: this.form.ID,
        gunNo: this.form.order_num,
        money: this.form.balance_dq,
        assets_code: this.form.assets_code
      })
        .then((res) => {
          this.$message.success(res.msg)
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
        })
    },
    // 关闭弹窗
    switchDialogShow() {
      this.show = !this.show
    }
  },
  beforeDestroy() {}
}
</script>

<style scoped lang="scss"></style>
